import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Collapsible, CollapsibleItem, Col, Button } from 'react-materialize'
import Indicator from '../data/IndicatorValueMap';



class IndicatorDropdown extends Component {
  constructor(props) {
   super(props);
   this.state = {
     indicatorMenu: false,
   };
   this.handleClick = this.handleClick.bind(this);
   this.indicatorClick = this.indicatorClick.bind(this);
  }

     handleClick(e) {
       var node = e.target;
       var hide = false;
       //console.log(node);
       while( node ){
         if( node.id === 'hide' ){
           hide = true;
           break;
         } else if (node.id === 'indicator-select'){
           hide = true;
           break;
         } else {
           node = node.parentNode;
         }
       }
       //console.log(hide);

       if (hide === false) {
         this.closeIndicator()
       }
     }

     componentWillMount() {
       document.addEventListener('click', this.handleClick, false);
     }

     componentWillUnmount() {
       document.removeEventListener('click', this.handleClick, false);
     }

     indicatorClick(){
       //alert("clicked");
       var clicked = this.state.indicatorMenu;
       this.setState({ indicatorMenu: !clicked});
     }

     closeIndicator(){
       this.setState({ indicatorMenu: false })
     }

     indicatorTitle(){
       const { demoValue, sedentaryValue, dietValue, tobaccoValue,
               alcoholValue, overweightValue, mentalValue } = this.props;

       var title = ''
       if(demoValue !== null){
         title = Indicator[demoValue]
       } else if ( sedentaryValue !== null){
         title = Indicator[sedentaryValue]
       } else if ( dietValue !== null) {
         title = Indicator[dietValue]
       } else if ( tobaccoValue !== null) {
         title = Indicator[tobaccoValue]
       } else if ( alcoholValue !== null) {
         title = Indicator[alcoholValue]
       } else if ( overweightValue !== null) {
         title = Indicator[overweightValue]
       } else if ( mentalValue !== null) {
         title = Indicator[mentalValue]
       } else {
         return 'Select a Different Indicator'


       }
       return title.slice(0, 60)
     }


  render() {
    var title = <div className="menu-label">
                  {this.indicatorTitle()}
                </div>
    if(this.props.display === "desktop"){
      return (
        <div>
          <div id="indicator-select"
               className="indicator-subgroup"
               onClick={() => this.indicatorClick()}
               style={{borderTop: 'solid 0.2px #ddd'}}>
            <div className="menu-label">{this.indicatorTitle()}</div>
            <FontAwesomeIcon icon="angle-down" />
          </div>
          <div id="hide">
            {
              this.state.indicatorMenu?(
              <div id="indicator-collasible" className="indicator-collapsible">
                <div className="indicator-subgroup" onClick={() => this.props.demoClick()}>
                  <div className="menu-label">{Indicator["demo"]}</div>
                  {this.props.demographicSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
                </div>
                {
                  this.props.demographicSelected?(
                    <div className="indicator-radio-group">
                      <div className="indicator-radio-button">
                          <Col s={1}>
                            <Button
                              type="button"
                              value="demo-1"
                              name="demographic"
                              onClick={(e)=> {this.props.demoValueChange(e); this.closeIndicator()}}
                              className={this.props.demoValue === 'demo-1'?"radio selected":"radio"} />
                          </Col>
                          <Col s={10}>
                            <label className="radio-label">{Indicator["demo-1"]}</label>
                          </Col>
                          <Col s={1}>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-1-i"]}</div>
                            </div>
                          </Col>
                      </div>
                      <div className="indicator-radio-button">
                        <Col s={1}>
                            <Button type="button"
                                    value="demo-2"
                                    name="demographic"
                                    onClick={(e)=> {this.props.demoValueChange(e); this.closeIndicator()}}
                                    className={this.props.demoValue === 'demo-2'?"radio selected":"radio"} />
                          </Col>
                          <Col s={10}>
                            <label className="radio-label">{Indicator["demo-2"]}</label>
                          </Col>
                          <Col s={1}>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-2-i"]}</div>
                            </div>
                          </Col>
                      </div>
                      <div className="indicator-radio-button">
                        <Col s={1}>
                            <Button type="button"
                                    value="demo-3"
                                    name="demographic"
                                    onClick={(e)=> {this.props.demoValueChange(e); this.closeIndicator()}}
                                    className={this.props.demoValue === 'demo-3'?"radio selected":"radio"} />
                          </Col>
                          <Col s={10}>
                            <label className="radio-label">{Indicator["demo-3"]}</label>
                          </Col>
                          <Col s={1}>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-3-i"]}</div>
                            </div>
                          </Col>
                      </div>
                      <div className="indicator-radio-button">
                        <Col s={1}>
                            <Button type="button"
                                    value="demo-4"
                                    name="demographic"
                                    onClick={(e)=> {this.props.demoValueChange(e); this.closeIndicator()}}
                                    className={this.props.demoValue === 'demo-4'?"radio selected":"radio"} />
                          </Col>
                          <Col s={10}>
                            <label className="radio-label">{Indicator["demo-4"]}</label>
                          </Col>
                          <Col s={1}>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-4-i"]}</div>
                            </div>
                          </Col>
                      </div>
                      <div className="indicator-radio-button">
                        <Col s={1}>
                            <Button type="button"
                                    value="demo-5"
                                    name="demographic"
                                    onClick={(e)=> {this.props.demoValueChange(e); this.closeIndicator()}}
                                    className={this.props.demoValue === 'demo-5'?"radio selected":"radio"} />
                          </Col>
                          <Col s={10}>
                            <label className="radio-label">{Indicator["demo-5"]}</label>
                          </Col>
                          <Col s={1}>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-5-i"]}</div>
                            </div>
                          </Col>
                      </div>
                    </div>
                  ):""
                }
                <div className="indicator-subgroup" onClick={() => this.props.sedentaryClick()}>
                  <div className="menu-label">{Indicator["sedentary"]}</div>
                  {this.props.sedentarySelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
                </div>
                {
                  this.props.sedentarySelected?(
                    <div className="indicator-radio-group">
                      <div className="indicator-radio-button">
                        <Col s={1}>
                          <Button type="button"
                                  value="sedentary-1"
                                  name="sedentary"
                                  onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeIndicator()}}
                                  className={this.props.sedentaryValue === 'sedentary-1'?"radio selected":"radio"} />
                        </Col>
                        <Col s={10}>
                          <label className="radio-label">{Indicator["sedentary-1"]}</label>
                        </Col>
                        <Col s={1}>
                          <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                             {Indicator["sedentary-1-i"]}</div>
                          </div>
                        </Col>
                      </div>
                      <div className="indicator-radio-button">
                        <Col s={1}>
                          <Button type="button"
                                  value="sedentary-2"
                                  name="sedentary"
                                  onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeIndicator()}}
                                  className={this.props.sedentaryValue === 'sedentary-2'?"radio selected":"radio"} />
                        </Col>
                        <Col s={10}>
                          <label className="radio-label">{Indicator["sedentary-2"]}</label>
                        </Col>
                        <Col s={1}>
                          <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                            {Indicator["sedentary-2-i"]}</div>
                          </div>
                        </Col>
                    </div>
                    <div className="indicator-radio-button">
                      <Col s={1}>
                        <Button type="button"
                                value="sedentary-3"
                                name="sedentary"
                                onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeIndicator()}}
                                className={this.props.sedentaryValue === 'sedentary-3'?"radio selected":"radio"} />
                      </Col>
                      <Col s={10}>
                        <label className="radio-label">{Indicator["sedentary-3"]}</label>
                      </Col>
                      <Col s={1}>
                        <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                          <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                          {Indicator["sedentary-3-i"]}</div>
                        </div>
                      </Col>
                    </div>
                    <div className="indicator-radio-button">
                      <Col s={1}>
                        <Button type="button"
                                value="sedentary-4"
                                name="sedentary"
                                onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeIndicator()}}
                                className={this.props.sedentaryValue === 'sedentary-4'?"radio selected":"radio"} />
                      </Col>
                      <Col s={10}>
                        <label className="radio-label">{Indicator["sedentary-4"]}</label>
                      </Col>
                      <Col s={1}>
                        <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                          <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                          {Indicator["sedentary-4-i"]}</div>
                        </div>
                      </Col>
                    </div>
                    <div className="indicator-radio-button">
                      <Col s={1}>
                        <Button type="button"
                                value="sedentary-5"
                                name="sedentary"
                                onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeIndicator()}}
                                className={this.props.sedentaryValue === 'sedentary-5'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["sedentary-5"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["sedentary-5-i"]}</div>
                      </div>
                    </Col>
                  </div>
                  {/* <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="sedentary-6"
                              name="sedentary"
                              onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeIndicator()}}
                              className={this.props.sedentaryValue === 'sedentary-6'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-6"]}</label>
                   </Col>
                 </div> */}
               </div>
             ):""
           }
           <div className="indicator-subgroup"  onClick={() => this.props.dietClick()}>
             <div className="menu-label">{Indicator["diet"]}</div>
             {this.props.dietSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
           </div>
           {
             this.props.dietSelected?(
               <div className="indicator-radio-group">
                 <div className="indicator-radio-button">
                   <Col s={1}>
                     <Button type="button"
                             value="diet-1"
                             name="diet"
                             onClick={(e)=>{this.props.dietValueChange(e); this.closeIndicator()}}
                             className={this.props.dietValue === 'diet-1'?"radio selected":"radio"} />
                   </Col>
                   <Col s={10}>
                     <label className="radio-label">{Indicator["diet-1"]}</label>
                   </Col>
                   <Col s={1}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["diet-1-i"]}</div>
                     </div>
                   </Col>
                 </div>
                 <div className="indicator-radio-button">
                   <Col s={1}>
                     <Button type="button"
                             value="diet-2"
                             name="diet"
                             onClick={(e)=>{this.props.dietValueChange(e); this.closeIndicator()}}
                             className={this.props.dietValue === 'diet-2'?"radio selected":"radio"} />
                   </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["diet-2"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["diet-2-i"]}</div>
                    </div>
                  </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="diet-3"
                            name="diet"
                            onClick={(e)=>{this.props.dietValueChange(e); this.closeIndicator()}}
                            className={this.props.dietValue === 'diet-3'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["diet-3"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["diet-3-i"]}</div>
                    </div>
                  </Col>
                </div>
                {/* <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="diet-4"
                            name="diet"
                            onClick={(e)=>{this.props.dietValueChange(e); this.closeIndicator()}}
                            className={this.props.dietValue === 'diet-4'?"radio selected":"radio"} />
                  </Col>
                  <Col s={9}>
                    <label className="radio-label">{Indicator["diet-4"]}</label>
                  </Col>
                </div> */}
              </div>
            ):""
          }
          <div className="indicator-subgroup" onClick={() => this.props.tobaccoClick()}>
            <div className="menu-label">{Indicator["tobacco"]}</div>
            {this.props.tobaccoSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
          </div>
          {
            this.props.tobaccoSelected?(
              <div className="indicator-radio-group">
                <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button
                      type="button"
                      value="tobacco-1"
                      name="tobacco"
                      onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                      className={this.props.tobaccoValue === 'tobacco-1'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["tobacco-1"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["tobacco-1-i"]}</div>
                    </div>
                  </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="tobacco-2"
                            name="tobacco"
                            onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                            className={this.props.tobaccoValue === 'tobacco-2'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["tobacco-2"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["tobacco-2-i"]}</div>
                    </div>
                  </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="tobacco-3"
                            name="tobacco"
                            onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                            className={this.props.tobaccoValue === 'tobacco-3'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["tobacco-3"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["tobacco-3-i"]}</div>
                    </div>
                  </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="tobacco-4"
                            name="tobacco"
                            onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                            className={this.props.tobaccoValue === 'tobacco-4'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["tobacco-4"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["tobacco-4-i"]}</div>
                    </div>
                  </Col>
                </div>
                 <div className="indicator-radio-button">
                    <Col s={1}>
                       <Button type="button"
                               value="tobacco-5"
                               name="tobacco"
                               onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                              className={this.props.tobaccoValue === 'tobacco-5'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                       <label className="radio-label">{Indicator["tobacco-5"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["tobacco-5-i"]}</div>
                      </div>
                    </Col>
                 </div>
                 <div className="indicator-radio-button">
                     <Col s={1}>
                       <Button type="button"
                               value="tobacco-6"
                               name="tobacco"
                               onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                               className={this.props.tobaccoValue === 'tobacco-6'?"radio selected":"radio"} />
                     </Col>
                     <Col s={10}>
                       <label className="radio-label">{Indicator["tobacco-6"]}</label>
                     </Col>
                     <Col s={1}>
                       <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                         <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["tobacco-6-i"]}</div>
                       </div>
                     </Col>
                 </div>
                 <div className="indicator-radio-button">
                     <Col s={1}>
                       <Button type="button"
                               value="tobacco-7"
                               name="tobacco"
                               onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                               className={this.props.tobaccoValue === 'tobacco-7'?"radio selected":"radio"} />
                     </Col>
                     <Col s={10}>
                       <label className="radio-label">{Indicator["tobacco-7"]}</label>
                     </Col>
                     <Col s={1}>
                       <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                         <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                         {Indicator["tobacco-7-i"]}</div>
                       </div>
                     </Col>
                 </div>
                 <div className="indicator-radio-button">
                     <Col s={1}>
                       <Button type="button"
                                value="tobacco-8"
                                name="tobacco"
                                onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                                className={this.props.tobaccoValue === 'tobacco-8'?"radio selected":"radio"} />
                     </Col>
                     <Col s={10}>
                       <label className="radio-label">{Indicator["tobacco-8"]}</label>
                     </Col>
                     <Col s={1}>
                       <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                         <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                         {Indicator["tobacco-8-i"]}</div>
                       </div>
                     </Col>
                 </div>
                 <div className="indicator-radio-button">
                     <Col s={1}>
                       <Button type="button"
                               value="tobacco-9"
                               name="tobacco"
                               onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeIndicator()}}
                              className={this.props.tobaccoValue === 'tobacco-9'?"radio selected":"radio"} />
                     </Col>
                     <Col s={10}>
                       <label className="radio-label">{Indicator["tobacco-9"]}</label>
                     </Col>
                     <Col s={1}>
                       <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                         <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                         {Indicator["tobacco-9-i"]}</div>
                       </div>
                     </Col>
                 </div>
               </div>
             ):""
            }
            <div className="indicator-subgroup" onClick={() => this.props.alcoholClick()}>
             <div className="menu-label">{Indicator["alcohol"]}</div>
             {this.props.alcoholSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
            </div>
            {
            this.props.alcoholSelected?(
              <div className="indicator-radio-group">
                <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="alcohol-1"
                              name="alcohol"
                              onClick={(e)=>{this.props.alcoholValueChange(e); this.closeIndicator()}}
                              className={this.props.alcoholValue === 'alcohol-1'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["alcohol-1"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["alcohol-1-i"]}</div>
                      </div>
                    </Col>
                  </div>
                  <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="alcohol-2"
                              name="alcohol"
                              onClick={(e)=>{this.props.alcoholValueChange(e); this.closeIndicator()}}
                              className={this.props.alcoholValue === 'alcohol-2'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["alcohol-2"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["alcohol-2-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="alcohol-3"
                              name="alcohol"
                              onClick={(e)=>{this.props.alcoholValueChange(e); this.closeIndicator()}}
                              className={this.props.alcoholValue === 'alcohol-3'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["alcohol-3"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["alcohol-3-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="alcohol-4"
                              name="alcohol"
                              onClick={(e)=>{this.props.alcoholValueChange(e); this.closeIndicator()}}
                              className={this.props.alcoholValue === 'alcohol-4'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["alcohol-4"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["alcohol-4-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="alcohol-5"
                              name="alcohol"
                              onClick={(e)=>{this.props.alcoholValueChange(e); this.closeIndicator()}}
                              className={this.props.alcoholValue === 'alcohol-5'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["alcohol-5"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                         {Indicator["alcohol-5-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                    <Col s={1}>
                      <Button type="button"
                              value="alcohol-6"
                              name="alcohol"
                              onClick={(e)=>{this.props.alcoholValueChange(e); this.closeIndicator()}}
                              className={this.props.alcoholValue === 'alcohol-6'?"radio selected":"radio"} />
                    </Col>
                    <Col s={10}>
                      <label className="radio-label">{Indicator["alcohol-6"]}</label>
                    </Col>
                    <Col s={1}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["alcohol-6-i"]}</div>
                      </div>
                    </Col>
                </div>
              </div>
            ):""
          }
          <div className="indicator-subgroup" onClick={() => this.props.overweightClick()}>
            <div className="menu-label">{Indicator["overweight"]}</div>
            {this.props.overweightSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
          </div>
          {
            this.props.overweightSelected?(
             <div className="indicator-radio-group">
               <div className="indicator-radio-button">
                   <Col s={1}>
                     <Button type="button"
                             value="overweight-1"
                             name="overweight"
                             onClick={(e)=>{this.props.overweightValueChange(e); this.closeIndicator()}}
                             className={this.props.overweightValue === 'overweight-1'?"radio selected":"radio"} />
                   </Col>
                   <Col s={10}>
                     <label className="radio-label">{Indicator["overweight-1"]}</label>
                   </Col>
                   <Col s={1}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["overweight-1-i"]}</div>
                     </div>
                   </Col>
               </div>
               <div className="indicator-radio-button">
                   <Col s={1}>
                     <Button type="button"
                             value="overweight-2"
                             name="overweight"
                             onClick={(e)=>{this.props.overweightValueChange(e); this.closeIndicator()}}
                             className={this.props.overweightValue === 'overweight-2'?"radio selected":"radio"} />
                   </Col>
                   <Col s={10}>
                     <label className="radio-label">{Indicator["overweight-2"]}</label>
                   </Col>
                   <Col s={1}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["overweight-2-i"]}</div>
                     </div>
                   </Col>
               </div>
               {/* <div className="indicator-radio-button">
                   <Col s={1}>
                     <Button type="button"
                             value="overweight-3"
                             name="overweight"
                             onClick={(e)=>{this.props.overweightValueChange(e); this.closeIndicator()}}
                             className={this.props.overweightValue === 'overweight-3'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["overweight-3"]}</label>
                   </Col>
               </div>
               <div className="indicator-radio-button">
                   <Col s={1}>
                     <Button type="button"
                             value="overweight-4"
                             name="overweight"
                             onClick={(e)=>{this.props.overweightValueChange(e); this.closeIndicator()}}
                             className={this.props.overweightValue === 'overweight-4'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["overweight-4"]}</label>
                   </Col>
               </div> */}
             </div>
            ):""
          }
          <div className="indicator-subgroup" onClick={() => this.props.mentalClick()}>
            <div className="menu-label">{Indicator["mental"]}</div>
            {this.props.mentalSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
            </div>
            {
            this.props.mentalSelected?(
              <div className="indicator-radio-group">
                <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="mental-1"
                            name="mental"
                            onClick={(e)=>{this.props.mentalValueChange(e);this.closeIndicator()}}
                            className={this.props.mentalValue === 'mental-1'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["mental-1"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["mental-1-i"]}</div>
                    </div>
                  </Col>
              </div>
              <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="mental-2"
                            name="mental"
                            onClick={(e)=>{this.props.mentalValueChange(e);this.closeIndicator()}}
                            className={this.props.mentalValue === 'mental-2'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["mental-2"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["mental-2-i"]}</div>
                    </div>
                  </Col>
              </div>
              <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="mental-3"
                            name="mental"
                            onClick={(e)=>{this.props.mentalValueChange(e);this.closeIndicator()}}
                            className={this.props.mentalValue === 'mental-3'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["mental-3"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["mental-3-i"]}</div>
                    </div>
                  </Col>
              </div>
              <div className="indicator-radio-button">
                  <Col s={1}>
                    <Button type="button"
                            value="mental-4"
                            name="mental"
                            onClick={(e)=>{this.props.mentalValueChange(e);this.closeIndicator()}}
                            className={this.props.mentalValue === 'mental-4'?"radio selected":"radio"} />
                  </Col>
                  <Col s={10}>
                    <label className="radio-label">{Indicator["mental-4"]}</label>
                  </Col>
                  <Col s={1}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["mental-4-i"]}</div>
                    </div>
                  </Col>
              </div>
            </div>
            ):""}
          </div>
        ):""
      }
    </div>
  </div>);
    } else {
      return (
        <div>
          <div className="indicator-subgroup"  onClick={() => this.props.demoClick()}>
            <div className="menu-label">{Indicator["demo"]}</div>
            {this.props.demographicSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
          </div>
          {
            this.props.demographicSelected?(
              <div className="indicator-radio-group">
                <div className="indicator-radio-button">
                    <Col s={1} onClick={(e)=>this.props.demoValueChange(e)}>
                      <Button type="button" value="demo-1" name="demographic" className={this.props.demoValue === 'demo-1'?"radio selected":"radio"} />
                    </Col>
                    <Col s={9}>
                      <label className="radio-label">{Indicator["demo-1"]}</label>
                    </Col>
                    <Col s={2}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["demo-1-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.demoValueChange(e)}>
                      <Button type="button" value="demo-2" name="demographic" className={this.props.demoValue === 'demo-2'?"radio selected":"radio"} />
                    </Col>
                    <Col s={9}>
                      <label className="radio-label">{Indicator["demo-2"]}</label>
                    </Col>
                    <Col s={2}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["demo-2-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.demoValueChange(e)}>
                      <Button type="button" value="demo-3" name="demographic" className={this.props.demoValue === 'demo-3'?"radio selected":"radio"} />
                    </Col>
                    <Col s={9}>
                      <label className="radio-label">{Indicator["demo-3"]}</label>
                    </Col>
                    <Col s={2}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["demo-3-i"]}</div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.demoValueChange(e)}>
                      <Button type="button" value="demo-4" name="demographic" className={this.props.demoValue === 'demo-4'?"radio selected":"radio"} />
                    </Col>
                    <Col s={9}>
                      <label className="radio-label">{Indicator["demo-4"]}</label>
                    </Col>
                    <Col s={2}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                          {Indicator["demo-4-i"]}
                        </div>
                      </div>
                    </Col>
                </div>
                <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.demoValueChange(e)}>
                      <Button type="button" value="demo-5" name="demographic" className={this.props.demoValue === 'demo-5'?"radio selected":"radio"} />
                    </Col>
                    <Col s={9}>
                      <label className="radio-label">{Indicator["demo-5"]}</label>
                    </Col>
                    <Col s={2}>
                      <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                        <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                        {Indicator["demo-5-i"]}</div>
                      </div>
                    </Col>
                </div>
              </div>
            ):""
          }
          <div className="indicator-subgroup" onClick={() => this.props.sedentaryClick()}>
            <div className="menu-label">{Indicator["sedentary"]}</div>
            {this.props.sedentarySelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
         </div>
         {
           this.props.sedentarySelected?(
             <div className="indicator-radio-group">
               <div className="indicator-radio-button">
                   <Col s={1} onClick={(e)=>this.props.sedentaryValueChange(e)}>
                     <Button type="button" value="sedentary-1" name="sedentary" className={this.props.sedentaryValue === 'sedentary-1'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-1"]}</label>
                   </Col>
                   <Col s={2}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["sedentary-1-i"]}</div>
                     </div>
                   </Col>
               </div>
               <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.sedentaryValueChange(e)}>
                     <Button type="button" value="sedentary-2" name="sedentary" className={this.props.sedentaryValue === 'sedentary-2'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-2"]}</label>
                   </Col>
                   <Col s={2}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["sedentary-2-i"]}</div>
                     </div>
                   </Col>
               </div>
               <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.sedentaryValueChange(e)}>
                     <Button type="button" value="sedentary-3" name="sedentary" className={this.props.sedentaryValue === 'sedentary-3'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-3"]}</label>
                   </Col>
                   <Col s={2}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["sedentary-3-i"]}</div>
                     </div>
                   </Col>
               </div>
               <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.sedentaryValueChange(e)}>
                     <Button type="button" value="sedentary-4" name="sedentary" className={this.props.sedentaryValue === 'sedentary-4'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-4"]}</label>
                   </Col>
                   <Col s={2}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["sedentary-4-i"]}</div>
                     </div>
                   </Col>
               </div>
               <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.sedentaryValueChange(e)}>
                     <Button type="button" value="sedentary-5" name="sedentary" className={this.props.sedentaryValue === 'sedentary-5'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-5"]}</label>
                   </Col>
                   <Col s={2}>
                     <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                       <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                       {Indicator["sedentary-5-i"]}</div>
                     </div>
                   </Col>
               </div>
               {/* <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.sedentaryValueChange(e)}>
                     <Button type="button" value="sedentary-6" name="sedentary" className={this.props.sedentaryValue === 'sedentary-5'?"radio selected":"radio"} />
                   </Col>
                   <Col s={9}>
                     <label className="radio-label">{Indicator["sedentary-6"]}</label>
                   </Col>
               </div> */}
             </div>
           ):""
         }
         <div className="indicator-subgroup" onClick={() => this.props.dietClick()}>
           <div className="menu-label">{Indicator["diet"]}</div>
           {this.props.dietSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
        </div>
        {
          this.props.dietSelected?(
            <div className="indicator-radio-group">
              <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.dietValueChange(e)}>
                    <Button type="button" value="diet-1" name="diet" className={this.props.dietValue === 'diet-1'?"radio selected":"radio"} />
                  </Col>
                  <Col s={9}>
                    <label className="radio-label">{Indicator["diet-1"]}</label>
                  </Col>
                  <Col s={2}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["diet-1-i"]}</div>
                    </div>
                  </Col>
              </div>
              <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.dietValueChange(e)}>
                    <Button type="button" value="diet-2" name="diet" className={this.props.dietValue === 'diet-2'?"radio selected":"radio"} />
                  </Col>
                  <Col s={9}>
                    <label className="radio-label">{Indicator["diet-2"]}</label>
                  </Col>
                  <Col s={2}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["diet-2-i"]}</div>
                    </div>
                  </Col>
              </div>
              <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.dietValueChange(e)}>
                    <Button type="button" value="diet-3" name="diet" className={this.props.dietValue === 'diet-3'?"radio selected":"radio"} />
                  </Col>
                  <Col s={9}>
                    <label className="radio-label">{Indicator["diet-3"]}</label>
                  </Col>
                  <Col s={2}>
                    <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                      <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                      {Indicator["diet-3-i"]}</div>
                    </div>
                  </Col>
              </div>
              {/* <div className="indicator-radio-button">
                  <Col s={1} onClick={(e)=>this.props.dietValueChange(e)}>
                    <Button type="button" value="diet-4" name="diet" className={this.props.dietValue === 'diet-4'?"radio selected":"radio"} />
                  </Col>
                  <Col s={9}>
                    <label className="radio-label">{Indicator["diet-4"]}</label>
                  </Col>
              </div> */}
            </div>
          ):""
        }
        <div className="indicator-subgroup" onClick={() => this.props.tobaccoClick()}>
          <div className="menu-label">{Indicator["tobacco"]}</div>
          {this.props.tobaccoSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
       </div>
       {
         this.props.tobaccoSelected?(
           <div className="indicator-radio-group">
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-1" name="tobacco" className={this.props.tobaccoValue === 'tobacco-1'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-1"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-1-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-2" name="tobacco" className={this.props.tobaccoValue === 'tobacco-2'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-2"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-2-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-3" name="tobacco" className={this.props.tobaccoValue === 'tobacco-3'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-3"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-3-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-4" name="tobacco" className={this.props.tobaccoValue === 'tobacco-4'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-4"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-4-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-5" name="tobacco" className={this.props.tobaccoValue === 'tobacco-5'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-5"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-5-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-6" name="tobacco" className={this.props.tobaccoValue === 'tobacco-6'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-6"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-6-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-7" name="tobacco" className={this.props.tobaccoValue === 'tobacco-7'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-7"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-7-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-8" name="tobacco" className={this.props.tobaccoValue === 'tobacco-8'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-8"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-8-i"]}</div>
                   </div>
                 </Col>
             </div>
             <div className="indicator-radio-button">
                 <Col s={1} onClick={(e)=>this.props.tobaccoValueChange(e)}>
                   <Button type="button" value="tobacco-9" name="tobacco" className={this.props.tobaccoValue === 'tobacco-9'?"radio selected":"radio"} />
                 </Col>
                 <Col s={9}>
                   <label className="radio-label">{Indicator["tobacco-9"]}</label>
                 </Col>
                 <Col s={2}>
                   <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                     <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                     {Indicator["tobacco-9-i"]}</div>
                   </div>
                 </Col>
             </div>
           </div>
         ):""
       }
       <div className="indicator-subgroup" onClick={() => this.props.alcoholClick()}>
         <div className="menu-label">{Indicator["alcohol"]}</div>
         {this.props.alcoholSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
      </div>
      {
        this.props.alcoholSelected?(
          <div className="indicator-radio-group">
            <div className="indicator-radio-button">
                <Col s={1} onClick={(e)=>this.props.alcoholValueChange(e)}>
                  <Button type="button" value="alcohol-1" name="alcohol" className={this.props.alcoholValue === 'alcohol-1'?"radio selected":"radio"} />
                </Col>
                <Col s={9}>
                  <label className="radio-label">{Indicator["alcohol-1"]}</label>
                </Col>
                <Col s={2}>
                  <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                    <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["alcohol-1-i"]}</div>
                  </div>
                </Col>
            </div>
            <div className="indicator-radio-button">
                <Col s={1} onClick={(e)=>this.props.alcoholValueChange(e)}>
                  <Button type="button" value="alcohol-2" name="alcohol" className={this.props.alcoholValue === 'alcohol-2'?"radio selected":"radio"} />
                </Col>
                <Col s={9}>
                  <label className="radio-label">{Indicator["alcohol-2"]}</label>
                </Col>
                <Col s={2}>
                  <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                    <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["alcohol-2-i"]}</div>
                  </div>
                </Col>
            </div>
            <div className="indicator-radio-button">
                <Col s={1} onClick={(e)=>this.props.alcoholValueChange(e)}>
                  <Button type="button" value="alcohol-3" name="alcohol" className={this.props.alcoholValue === 'alcohol-3'?"radio selected":"radio"} />
                </Col>
                <Col s={9}>
                  <label className="radio-label">{Indicator["alcohol-3"]}</label>
                </Col>
                <Col s={2}>
                  <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                    <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["alcohol-3-i"]}</div>
                  </div>
                </Col>
            </div>
            <div className="indicator-radio-button">
                <Col s={1} onClick={(e)=>this.props.alcoholValueChange(e)}>
                  <Button type="button" value="alcohol-4" name="alcohol" className={this.props.alcoholValue === 'alcohol-4'?"radio selected":"radio"} />
                </Col>
                <Col s={9}>
                  <label className="radio-label">{Indicator["alcohol-4"]}</label>
                </Col>
                <Col s={2}>
                  <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                    <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["alcohol-4-i"]}</div>
                  </div>
                </Col>
            </div>
            <div className="indicator-radio-button">
                <Col s={1} onClick={(e)=>this.props.alcoholValueChange(e)}>
                  <Button type="button" value="alcohol-5" name="alcohol" className={this.props.alcoholValue === 'alcohol-5'?"radio selected":"radio"} />
                </Col>
                <Col s={9}>
                  <label className="radio-label">{Indicator["alcohol-5"]}</label>
                </Col>
                <Col s={2}>
                  <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                    <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["alcohol-5-i"]}</div>
                  </div>
                </Col>
            </div>
            <div className="indicator-radio-button">
                <Col s={1} onClick={(e)=>this.props.alcoholValueChange(e)}>
                  <Button type="button" value="alcohol-6" name="alcohol" className={this.props.alcoholValue === 'alcohol-6'?"radio selected":"radio"} />
                </Col>
                <Col s={9}>
                  <label className="radio-label">{Indicator["alcohol-6"]}</label>
                </Col>
                <Col s={2}>
                  <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                    <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["alcohol-6-i"]}</div>
                  </div>
                </Col>
            </div>
          </div>
        ):""
      }
      <div className="indicator-subgroup" onClick={() => this.props.overweightClick()}>
        <div className="menu-label">{Indicator["overweight"]}</div>
        {this.props.overweightSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
     </div>
     {
       this.props.overweightSelected?(
         <div className="indicator-radio-group">
           <div className="indicator-radio-button">
               <Col s={1} onClick={(e)=>this.props.overweightValueChange(e)}>
                 <Button type="button" value="overweight-1" name="overweight" className={this.props.overweightValue === 'overweight-1'?"radio selected":"radio"} />
               </Col>
               <Col s={9}>
                 <label className="radio-label">{Indicator["overweight-1"]}</label>
               </Col>
               <Col s={2}>
                 <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                   <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                   {Indicator["overweight-1-i"]}</div>
                 </div>
               </Col>
           </div>
           <div className="indicator-radio-button">
               <Col s={1} onClick={(e)=>this.props.overweightValueChange(e)}>
                 <Button type="button" value="overweight-2" name="overweight" className={this.props.overweightValue === 'overweight-2'?"radio selected":"radio"} />
               </Col>
               <Col s={9}>
                 <label className="radio-label">{Indicator["overweight-2"]}</label>
               </Col>
               <Col s={2}>
                 <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                   <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                   {Indicator["overweight-2-i"]}</div>
                 </div>
               </Col>
           </div>
           {/* <div className="indicator-radio-button">
               <Col s={1} onClick={(e)=>this.props.overweightValueChange(e)}>
                 <Button type="button" value="overweight-3" name="overweight" className={this.props.overweightValue === 'overweight-3'?"radio selected":"radio"} />
               </Col>
               <Col s={9}>
                 <label className="radio-label">{Indicator["overweight-3"]}</label>
               </Col>
           </div>
           <div className="indicator-radio-button">
               <Col s={1} onClick={(e)=>this.props.overweightValueChange(e)}>
                 <Button type="button" value="overweight-4" name="overweight" className={this.props.overweightValue === 'overweight-4'?"radio selected":"radio"} />
               </Col>
               <Col s={9}>
                 <label className="radio-label">{Indicator["overweight-4"]}</label>
               </Col>
           </div> */}
         </div>
       ):""
     }
     <div className="indicator-subgroup" onClick={() => this.props.mentalClick()}>
       <div className="menu-label">{Indicator["mental"]}</div>
       {this.props.mentalSelected?<FontAwesomeIcon icon="angle-down" />:<FontAwesomeIcon icon="angle-right" />}
    </div>
    {
      this.props.mentalSelected?(
        <div className="indicator-radio-group">
          <div className="indicator-radio-button">
              <Col s={1} onClick={(e)=>this.props.mentalValueChange(e)}>
                <Button type="button" value="mental-1" name="mental" className={this.props.mentalValue === 'mental-1'?"radio selected":"radio"} />
              </Col>
              <Col s={9}>
                <label className="radio-label">{Indicator["mental-1"]}</label>
              </Col>
              <Col s={2}>
                <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                  <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                  {Indicator["mental-1-i"]}</div>
                </div>
              </Col>
          </div>
          <div className="indicator-radio-button">
              <Col s={1} onClick={(e)=>this.props.mentalValueChange(e)}>
                <Button type="button" value="mental-2" name="mental" className={this.props.mentalValue === 'mental-2'?"radio selected":"radio"} />
              </Col>
              <Col s={9}>
                <label className="radio-label">{Indicator["mental-2"]}</label>
              </Col>
              <Col s={2}>
                <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                  <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["mental-2-i"]}</div>
                </div>
              </Col>
          </div>
          <div className="indicator-radio-button">
              <Col s={1} onClick={(e)=>this.props.mentalValueChange(e)}>
                <Button type="button" value="mental-3" name="mental" className={this.props.mentalValue === 'mental-3'?"radio selected":"radio"} />
              </Col>
              <Col s={9}>
                <label className="radio-label">{Indicator["mental-3"]}</label>
              </Col>
              <Col s={2}>
                <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                  <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                    {Indicator["mental-3-i"]}</div>
                </div>
              </Col>
          </div>
          <div className="indicator-radio-button">
              <Col s={1} onClick={(e)=>this.props.mentalValueChange(e)}>
                <Button type="button" value="mental-4" name="mental" className={this.props.mentalValue === 'mental-4'?"radio selected":"radio"} />
              </Col>
              <Col s={9}>
                <label className="radio-label">{Indicator["mental-4"]}</label>
              </Col>
              <Col s={2}>
                <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                  <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                  {Indicator["mental-4-i"]}</div>
                </div>
              </Col>
          </div>
        </div>
      ):""
    }

  </div>
      )
    }

  }
}

export default IndicatorDropdown;



// WEBPACK FOOTER //
// ./src/components/IndicatorDropdown.js